import { Pipe, PipeTransform } from '@angular/core';
import { displayInboundFaxStatus } from 'app/core/options/inbound-fax-status.opts';

@Pipe({ name: 'faxStatus' })
export class FaxStatusPipe implements PipeTransform {
  transform = displayInboundFaxStatus
}
